export default {
  brand: "USFansLink",
  nav_spreadsheet: "Feuille de calcul",
  nav_guides: "Guides",
  nav_reviews: "Avis",
  nav_shipping: "Livraison",
  nav_coupon: "Coupons",
  nav_warehouse: "Entrepôt",
  nav_safety: "Sécurité",
  nav_faq: "FAQ",
  nav_home: "Accueil",
  nav_shopping_guide: "Guide d'achat",
  explore_main: "Explorer le site principal",
  back_home: "Retour à l'accueil",
  read_more: "Lire la suite",
  visit_main: "Visiter le site principal",
  independent_note: "Ressource informative indépendante · Sans affiliation officielle avec USFans",
  language_label: "Langue",
  cat_shoes: "Chaussures",
  cat_hoodies: "Sweats / Pulls",
  cat_tshirts: "T-shirts",
  cat_jackets: "Vestes",
  cat_pants: "Pantalons / Shorts",
  cat_headwear: "Couvre-chefs",
  cat_sets: "Ensembles",
  cat_underwear: "Sous-vêtements / Caleçons",
  cat_jersey: "Maillots",
  cat_accessories: "Accessoires",
  cat_bags: "Sacs",
  cat_belts: "Ceintures",
  cat_perfumes: "Parfums",
  cat_other: "Autres articles",
  footer_resources: "Ressources",
  footer_company: "Entreprise",
  footer_links: "Liens rapides",
  footer_about: "À propos",
  footer_contact: "Contact",
  footer_editorial: "Politique éditoriale",
  footer_updates: "Mises à jour",
  footer_disclaimer: "Avertissement",
  footer_privacy: "Politique de confidentialité",
  footer_terms: "Conditions",
  footer_rights: "Tous droits réservés.",
  footer_tagline: "Un hub indépendant de ressources, de guides et d'informations de sécurité sur la feuille de calcul USFans.",
};